import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { Card, CardBody } from "reactstrap"
import { toast } from "react-hot-toast"
import { SearchBox } from "components/SearchBox"

import ActionEyeIcon from "assets/images/icons/feather-eye-icon.png"
import { ScrapReturnForm } from "pages/Common/ScrapReturn"
import { DataTable } from "components/DataTable"
import { Pagination } from "components/Pagination"
import { Modal } from "components/Modal"
import { AutoComplete } from "components/AutoComplete"
import { useLocalPaginatedRequest } from "hooks/useLocalPaginatedRequest"
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils"
import {
   getSelectBoxOptionsFromConstants,
   truncateString,
} from "utils/commonUtils"
import {
   GetScrapReturnListing,
   GetScrapReturnRequestById,
   WarehouseListing,
} from "api/api.service"
import { ScrapReturnType } from "constants"
import Config from "Config"
import { Refresh } from "components/Refresh"
import { UserRoles } from "constants"
import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"

const COLUMNS = {
   SKU_NO: "SKU No.",
   ITEM_NAME: "Item Name",
   TYPE: "Type",
   QUANTITY: "Quantity",
   ISSUES: "Issues",
   DATE_OF_REQUEST: "Requested Date",
   WAREHOUSE: "Warehouse Name",
   ACTION: "Action",
}

const DATA_KEY = "data"
const TOTAL_KEY = "total"
const SCRAP_REQUEST = "WAREHOUSE"
const CHARACTER_LIMIT = 20

const ScrapReturnListing = ({}) => {
   let controller = new AbortController()
   let signal = controller.signal
   let typeOptions = getSelectBoxOptionsFromConstants(ScrapReturnType)

   const [filters, setFilters] = useState(null)
   const [toggleModal, setToggleModal] = useState(false)
   const [warehouseFilters, setWarehouseFilters] = useState(null)
   const [isFetchingRequest, setIsFetchingRequest] = useState(false)
   const [selectedListItem, setSelectedListItem] = useState("")
   const [warehouseListing, setWarehouseListing] = useState({
      data: [],
      fetching: true,
      page: 1,
      Q: "",
      isDataAvailable: false,
   })

   const {
      page,
      data,
      total,
      pageSize,
      isFetching,
      searchText,
      request,
      handleSearchChange,
      handlePageClick,
      onChangePageSize,
   } = useLocalPaginatedRequest({
      requestFn: GetScrapReturnListing,
      params: {
         ...{ type: UserRoles.Warehouse },
         ...(filters?.value && { requestType: filters?.value }),
         ...(warehouseFilters?.length && {
            id: warehouseFilters.map(item => item.value).join(),
         }),
      },
      deps: [filters, warehouseFilters],
      dataKey: DATA_KEY,
      totalKey: TOTAL_KEY,
   })

   const handleViewScrapDetails = async (scrapId = null) => {
      if (!scrapId) return

      let paramsObj = {
         type: UserRoles.Warehouse,
      }

      setToggleModal(true)

      try {
         setIsFetchingRequest(true)
         let res = await GetScrapReturnRequestById(scrapId, paramsObj)
         setSelectedListItem(res)
      } catch (err) {
         // toast.error(err.message)
      } finally {
         setIsFetchingRequest(false)
      }
   }

   const handleSelectOption = option => {
      setFilters(option)
   }

   useEffect(() => {
      handleWarehouseListing(warehouseListing.page)

      return () => {
         controller.abort()
      }
   }, [warehouseListing.Q])

   const handleSelectDepartments = option => {
      if (typeof option != "object" || !option) return
      setWarehouseFilters(option)
   }
   const handleDepartmentSearch = (value = "", callback) => {
      if (!value) return

      callback(prev => {
         return {
            ...prev,
            data: [],
            page: 1,
            Q: value,
         }
      })
   }

   const handleWarehouseListing = page => {
      setWarehouseListing(prev => {
         return {
            ...prev,
            fetching: true,
         }
      })

      WarehouseListing(
         {
            Limit: Config.LIMIT,
            ...(warehouseListing.Q && { Q: warehouseListing.Q }),
            Page: page,
         },
         signal
      )
         .then(res => {
            setWarehouseListing(prev => ({
               ...prev,
               fetching: false,
               page: page + 1,
               isDataAvailable: res?.data?.length == Config.LIMIT,
               data: (() => {
                  let test = res?.data?.map(item => ({
                     ...item,
                     value: item.id,
                     label: item.warehouseName,
                  }))

                  return [...test]
               })(),
            }))
         })
         .finally(() => {
            setWarehouseListing(prev => {
               return {
                  ...prev,
                  fetching: false,
               }
            })
         })
   }

   return (
      <>
         <Card className="mb-5">
            <Refresh onClick={request} />
            <CardBody className="p-2 p-md-4">
               <div className="mb-2">
                  <div className="d-flex align-items-center justify-content-between admin-inventory-request-form-fields ">
                     <div className="d-flex justify-content-start align-items-center admin-inventory-request-autocomplete">
                        <div className="wh-im-dpgi-status margin-right-handle me-2">
                           <AutoComplete
                              isMulti
                              placeholder="Warehouses"
                              value={warehouseFilters}
                              customStyles={autoCompleteStyles.STYLE_ONE}
                              handleBlur={() =>
                                 setWarehouseListing(prev => {
                                    return {
                                       ...prev,
                                       page: 1,
                                       Q: "",
                                    }
                                 })
                              }
                              onInputChange={val =>
                                 handleDepartmentSearch(
                                    val,
                                    setWarehouseListing
                                 )
                              }
                              options={warehouseListing.data}
                              onChange={val => handleSelectDepartments(val)}
                              closeMenuOnSelect={true}
                              isLoading={warehouseListing?.fetching}
                              classNamePrefix="status-header-search-admin"
                           />
                        </div>
                        <div className="min-250-w margin-top-handle">
                           <AutoComplete
                              value={filters}
                              isClearable
                              placeholder="Select status"
                              isSearchable={false}
                              customStyles={autoCompleteStyles.STYLE_ONE}
                              classNamePrefix="status-header-search-admin"
                              options={typeOptions}
                              onChange={val => handleSelectOption(val)}
                           />
                        </div>
                     </div>
                     <div className="location-search-box ad-search-container">
                        <SearchBox
                           inputClasses="vendor-search-input input-search"
                           labelClass="d-none"
                           placeholder="Search"
                           searchIcon={true}
                           searchIconClass="vendor-table-search-icon"
                           conClass="vendor-table-search-inner-class admin-inventory-request-search-box-responsive"
                           searchText={searchText}
                           onChange={handleSearchChange}
                        />
                     </div>
                  </div>
               </div>
               <div className="scrollable-table">
                  <DataTable
                     data={data}
                     loading={isFetching}
                     tableClasses="ad-scrapreturn-inventory-request-table"
                     config={[
                        {
                           title: COLUMNS.SKU_NO,
                           render: data => {
                              return (
                                 <>
                                    <div
                                       onClick={() =>
                                          setInventoryDetailsModal(true)
                                       }
                                    >
                                       {data.skuNo || "-"}
                                    </div>
                                 </>
                              )
                           },
                        },
                        {
                           title: COLUMNS.ITEM_NAME,
                           render: data => {
                              return data?.itemName || "-"
                           },
                        },
                        {
                           title: COLUMNS.WAREHOUSE,
                           render: data => {
                              return (
                                 <>{data?.warehouse?.warehouseName || "-"}</>
                              )
                           },
                        },
                        {
                           title: COLUMNS.TYPE,
                           render: data => {
                              return data?.type || "-"
                           },
                        },

                        {
                           title: COLUMNS.QUANTITY,
                           render: data => {
                              return <>{data.quantity || "-"}</>
                           },
                        },
                        {
                           title: COLUMNS.ISSUES,
                           render: data => {
                              if (data?.issue?.length > CHARACTER_LIMIT) {
                                 return (
                                    <div data-container={data?.issue}>
                                       {truncateString(
                                          data?.issue,
                                          CHARACTER_LIMIT
                                       )}
                                    </div>
                                 )
                              } else {
                                 return data?.issue || "-"
                              }
                           },
                        },

                        {
                           title: COLUMNS.DATE_OF_REQUEST,
                           render: data => {
                              return (
                                 convertDateTime({
                                    date: data.createdAt,
                                    customFormat:
                                       dateTimeFormat.casitaCustomDateFormat,
                                    dateOnly: true,
                                 }) || "-"
                              )
                           },
                        },
                        {
                           className: "text-center",
                           title: COLUMNS.ACTION,
                           render: data => {
                              return (
                                 <span
                                    className="text-success pointer"
                                    onClick={() =>
                                       handleViewScrapDetails(data.id)
                                    }
                                 >
                                    <img src={ActionEyeIcon} />
                                 </span>
                              )
                           },
                        },
                     ]}
                  />
               </div>
               <Pagination
                  currentPage={page}
                  totalData={total}
                  onPageClick={handlePageClick}
                  rowLimit={pageSize}
                  onChangePageSize={onChangePageSize}
               />
            </CardBody>
         </Card>
         <Modal
            isOpen={toggleModal}
            handleModalToggling={() => setToggleModal(false)}
            sizeClasses="10"
         >
            <ScrapReturnForm
               data={selectedListItem}
               closeModal={() => setToggleModal(false)}
            />
         </Modal>
      </>
   )
}

export default ScrapReturnListing
